import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { MailIcon, PhoneIcon } from "@heroicons/react/outline"

const Footer = () => {
  return (
    <footer className="bg-white">
      <div className="max-w-screen-2xl mx-auto grid grid-cols-2 lg:grid-cols-3 items-center px-4 pt-12">
        <div className="col-span-1">
          <ul className="font-body text-xl">
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <a href="/catalogue">Shop All</a>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <Link to="/articles">Discover</Link>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <Link to="/contact">Contact</Link>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <Link to="/privacy">Policies</Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1 text-center">
          <StaticImage
            src="../assets/Elemental Connection Logo.png"
            height={400}
            alt="elemental connection logo"
          />
        </div>
        <div className="hidden sm:block col-span-1 text-right">
          <ul className="font-body text-xl">
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <a href="tel:0424979703" target="_blank">
                0424 979 703
              </a>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <a href="mailto:admin@elementalconnection.com.au" target="_blank">
                admin@elementalconnection.com.au
              </a>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <a
                href="https://www.google.com/maps/place/Elemental+Connection/@-27.5204493,153.2563375,17z/data=!3m1!4b1!4m6!3m5!1s0x6b915d92a4942a17:0x393700400588f9c6!8m2!3d-27.5204493!4d153.2589124!16s%2Fg%2F11b8_wv7ld?entry=ttu&g_ep=EgoyMDI0MTAwMS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
              >
                Shop 1a / 1-7 Finucane Rd
              </a>
            </li>
            <li className="py-2 text-gray-500 hover:text-gray-800 transition ">
              <a
                href="https://www.google.com/maps/place/Elemental+Connection/@-27.5204493,153.2563375,17z/data=!3m1!4b1!4m6!3m5!1s0x6b915d92a4942a17:0x393700400588f9c6!8m2!3d-27.5204493!4d153.2589124!16s%2Fg%2F11b8_wv7ld?entry=ttu&g_ep=EgoyMDI0MTAwMS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
              >
                Capalaba QLD 4157
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex justify-center space-x-6 md:order-2">
          <a
            href="tel:0424979703"
            className="text-gray-400 hover:text-ec-earth"
          >
            <span className="sr-only">Phone</span>
            <PhoneIcon className="h-6 w-6" />
          </a>
          <a
            href="mailto:deanne@elementalconnection.com.au"
            className="text-gray-400 hover:text-ec-earth"
          >
            <span className="sr-only">Mail</span>
            <MailIcon className="h-6 w-6" />
          </a>
          <a
            href="https://www.facebook.com/elementalconnection/"
            target="blank"
            className="text-gray-400 hover:text-ec-earth"
          >
            <span className="sr-only">Facebook</span>
            <svg
              className="h-6 w-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                clipRule="evenodd"
              />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/elementalconnection/?hl=en"
            target="blank"
            className="text-gray-400 hover:text-ec-earth"
          >
            <span className="sr-only">Instagram</span>
            <svg
              className="h-6 w-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
        <div className="mt-8 md:mt-0 md:order-1 flex flex-col lg:flex-row gap-6">
          <div className="flex justify-center space-x-2">
            <div className="text-gray-400 hover:text-ec-earth">
              <span className="sr-only">Visa</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="24"
                aria-labelledby="pi-visa"
              >
                <path
                  opacity=".07"
                  d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                />
                <path
                  fill="#fff"
                  d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                />
                <path
                  d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                  fill="#142688"
                />
              </svg>
            </div>
            <div className="text-gray-400 hover:text-ec-earth">
              <span className="sr-only">Mastercard</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="24"
                aria-labelledby="pi-master"
              >
                <path
                  opacity=".07"
                  d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                />
                <path
                  fill="#fff"
                  d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                />
                <circle fill="#EB001B" cx="15" cy="12" r="7" />
                <circle fill="#F79E1B" cx="23" cy="12" r="7" />
                <path
                  fill="#FF5F00"
                  d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
                />
              </svg>
            </div>
            <div className="text-gray-400 hover:text-ec-earth">
              <span className="sr-only">American Express</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="24"
                aria-labelledby="pi-american_express"
              >
                <g fill="none">
                  <path
                    fill="#000"
                    d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                    opacity=".07"
                  />
                  <path
                    fill="#006FCF"
                    d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                  />
                  <path
                    fill="#FFF"
                    d="M8.971 10.268l.774 1.876H8.203l.768-1.876zm16.075.078h-2.977v.827h2.929v1.239h-2.923v.922h2.977v.739l2.077-2.245-2.077-2.34-.006.858zm-14.063-2.34h3.995l.887 1.935L16.687 8h10.37l1.078 1.19L29.25 8h4.763l-3.519 3.852 3.483 3.828h-4.834l-1.078-1.19-1.125 1.19H10.03l-.494-1.19h-1.13l-.495 1.19H4L7.286 8h3.43l.267.006zm8.663 1.078h-2.239l-1.5 3.536-1.625-3.536H12.06v4.81L10 9.084H8.007l-2.382 5.512H7.18l.494-1.19h2.596l.494 1.19h2.72v-3.935l1.751 3.941h1.19l1.74-3.929v3.93h1.458l.024-5.52-.001.001zm9.34 2.768l2.531-2.768h-1.822l-1.601 1.726-1.548-1.726h-5.894v5.518h5.81l1.614-1.738 1.548 1.738h1.875l-2.512-2.75h-.001z"
                  />
                </g>
              </svg>
            </div>
            <div className="text-gray-400 hover:text-ec-earth">
              <span className="sr-only">Afterpay</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="24"
                aria-labelledby="pi-afterpay"
              >
                <path
                  fill="#b2fce4"
                  d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                />
                <path d="M27.4 6.8l-2.7-1.6L22 3.6c-1.8-1-4.1.3-4.1 2.4v.4c0 .2.1.4.3.5l1.3.7c.4.2.8-.1.8-.5v-.8c0-.4.4-.7.8-.5l2.5 1.4L26 8.7c.4.2.4.7 0 .9L23.5 11 21 12.6c-.4.2-.8-.1-.8-.5v-.4c0-2.1-2.3-3.4-4.1-2.4l-2.7 1.6-2.7 1.6c-1.8 1-1.8 3.7 0 4.7l2.7 1.6 2.7 1.6c1.8 1 4.1-.3 4.1-2.4v-.4c0-.2-.1-.4-.3-.5l-1.3-.7c-.4-.2-.8.1-.8.5v.8c0 .4-.4.7-.8.5l-2.5-1.4-2.5-1.5c-.4-.2-.4-.7 0-.9l2.5-1.4 2.5-1.4c.4-.2.8.1.8.5v.4c0 2.1 2.3 3.4 4.1 2.4l2.7-1.6 2.7-1.6c1.9-1.2 1.9-3.8.1-4.9z" />
              </svg>
            </div>
          </div>
          <p className="text-center text-base text-gray-400">
            &copy; 2022 Elemental Connection. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
